import { createFileRoute, redirect } from "@tanstack/react-router";
import { tenantDetailSearch } from "@/features/operator/tenantDetailSearch";

export const Route = createFileRoute("/app/operator/tenants/$tenantId")({
  validateSearch: tenantDetailSearch,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/app/operator/users",
      search: { open: !search.tab || search.tab === "users" ? search.open : undefined },
      replace: true,
    });
  },
});
